// extracted by css-extract-rspack-plugin
export default {"wrapper_items":"OrmR5um09RQfTEB2","item":"JRM4c5HOTxUhm9ki","item__content":"fz5GwrlWZagaZKBx","item__title":"PHMtsJ4m1CgZi0BI","button":"t2Km88JyzwlFJFuI"};